/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Ex_PullupInputs */

const en_features_ex_pullup = /** @type {(inputs: Features_Ex_PullupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pull-up`)
};

const pl_features_ex_pullup = /** @type {(inputs: Features_Ex_PullupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podciąganie`)
};

/**
* | output |
* | --- |
* | "Pull-up" |
*
* @param {Features_Ex_PullupInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_ex_pullup = /** @type {((inputs?: Features_Ex_PullupInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Ex_PullupInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_ex_pullup(inputs)
	return en_features_ex_pullup(inputs)
});